export const AUTOMATIC_CONFIG_EN = {
  automaticProcurementConfigManagement: 'Automatic Procurement Config',
}
